import { Component, Input, OnInit } from '@angular/core';
import { LoadingService } from 'src/app/services/loading.service';
import { SavedPropertiesService } from 'src/app/services/saved-properties.service';
import { UtilsPropertiesService } from 'src/app/services/utils-properties.service';
import { environment } from 'src/environments/environment';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-list-view',
  templateUrl: './list-view.component.html',
  styleUrls: ['./list-view.component.css']
})
export class ListViewComponent implements OnInit {
  @Input() properties!: any[];
  // @Input() isMobile!: boolean;

  constructor(
    public loadingService: LoadingService,
    public savedService: SavedPropertiesService,
    public utilsPropertiesService: UtilsPropertiesService
  ) { }

  ngOnInit(): void {
  }

  getDistance(distance: number) {
    if (distance > 1000) {
      return (distance / 1000).toFixed(2) + 'km';
    } else {
      return distance + 'mts'
    }
  }

  getDivisions(divisions: { tag: string, value: any }[]) {
    if (!divisions)
      return [];

    const icons: any = {
      "Bedrooms": "bedrooms.svg",
      "Bathrooms": "bathrooms.svg",
      "Kitchens": "kitchens.svg",
    }
    return divisions.filter(div => ['Bedrooms', 'Bathrooms', 'Kitchens'].includes(div.tag)).map(div => {
      return {
        ...div,
        icon: icons[div.tag]
      }
    });
  }

  priceFormat(propertyPrice: any, symbol: any = '€') {
    const spaces = (price: any) => String(price)
      .replace(
        /(?!^)(?=(?:\d{3})+$)/g,
        ' '
      );
    return symbol + ' ' + spaces(propertyPrice);
  }

}
